import MuiGrid from '@mui/material/Grid';
import styled from 'styled-components';

const StyledGrid = styled(MuiGrid)`
  &.MuiGrid-spacing-xs-1 {
    width: calc(100% + 8px);
    margin: -4px;

    & > .MuiGrid-item {
      padding: 4px;
    }
  }

  &.MuiGrid-spacing-xs-2 {
    width: calc(100% + 16px);
    margin: -8px;

    & > .MuiGrid-item {
      padding: 8px;
    }
  }

  &.MuiGrid-spacing-xs-3 {
    width: calc(100% + 24px);
    margin: -12px;

    & > .MuiGrid-item {
      padding: 12px;
    }
  }

  &.MuiGrid-spacing-xs-4 {
    width: calc(100% + 32px);
    margin: -16px;

    & > .MuiGrid-item {
      padding: 16px;
    }
  }

  &.MuiGrid-spacing-xs-5 {
    width: calc(100% + 40px);
    margin: -20px;

    & > .MuiGrid-item {
      padding: 20px;
    }
  }
`;

// TODO: type props
export default function Grid(props: any) {
  return <StyledGrid {...props}></StyledGrid>;
}
